import DOMPurify from 'dompurify';

/**
 * Sanitize HTML string for safe use in dangerouslySetInnerHTML.
 * Strips script tags, event handlers, javascript: hrefs, etc.
 * Preserves safe formatting tags (b, i, u, p, br, ul, ol, li, a, img, table, etc.)
 */
export function sanitizeHtml(dirty) {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, {
    USE_PROFILES: { html: true }
  });
}

/**
 * Convenience wrapper — returns the object expected by dangerouslySetInnerHTML.
 */
export function sanitizedInnerHtml(dirty) {
  return { __html: sanitizeHtml(dirty) };
}
